// src/hooks/useAnalytics.js

import { useCallback } from 'react';
import { AnalyticsService } from '../apiService';

/**
 * Hook pour accéder aux données analytics
 */
export const useAnalytics = () => {
  const getStats = useCallback(async (days = 30) => {
    try {
      const response = await AnalyticsService.getStats(days);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch analytics stats:', error);
      return null;
    }
  }, []);

  const getPopularArticles = useCallback(async (days = 30, limit = 10) => {
    try {
      const response = await AnalyticsService.getPopularArticles(days, limit);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch popular articles:', error);
      return null;
    }
  }, []);

  const getStatsByCountry = useCallback(async (days = 30) => {
    try {
      const response = await AnalyticsService.getStatsByCountry(days);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch stats by country:', error);
      return null;
    }
  }, []);

  const getStatsByTime = useCallback(async (days = 30) => {
    try {
      const response = await AnalyticsService.getStatsByTime(days);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch stats by time:', error);
      return null;
    }
  }, []);

  const getArticleStats = useCallback(async (articleId, days = 30) => {
    try {
      const response = await AnalyticsService.getArticleStats(articleId, days);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch article stats:', error);
      return null;
    }
  }, []);

  const getLocationPoints = useCallback(async (days = 30) => {
  try {
    const response = await AnalyticsService.getLocationPoints(days);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch location points:', error);
    return [];
  }
}, []);

  return {
    getStats,
    getPopularArticles,
    getStatsByCountry,
    getStatsByTime,
    getArticleStats,
    getLocationPoints
  };
};
